import { gql } from '@apollo/client';
const ADD_PRODUCT_MAIN_CATEGORY = gql `
  mutation AddProductMainCategory($name: String!, $description: String, $thumbnail: String) {
    addProductMainCategory(name: $name, description: $description, thumbnail: $thumbnail) {
      productMainCategory {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default ADD_PRODUCT_MAIN_CATEGORY;
